export const meta = {
  title: 'அறிவிப்புகள்: உங்கள் வாடிக்கையாளர்களுக்கு எப்போது என்ன கிடைக்கும்',
  updatedAt: '2026-07-17',
  related: ['broadcasts', 'queue-board'],
};

உங்கள் வாடிக்கையாளர்கள் ஜன்னலோரம் நின்று காரைப் பார்த்துக்கொண்டிருக்க மாட்டார்கள் — ஆப் அவர்களுக்குச் சொல்லும். எந்த அறிவிப்புகள் உண்மையில் உள்ளன, அவை வர எது உண்மையாக இருக்க வேண்டும், எது இன்னும் கட்டப்படவில்லை — இந்தப் பக்கம் துல்லியமாகப் பட்டியலிடுகிறது.

## தானியங்கி அறிவிப்புகள்

உங்கள் வரிசைப் பலகையில் நடக்கும் ஒவ்வொரு டிக்கெட் நகர்வும், முன்பதிவு செய்த வாடிக்கையாளருக்கு ஒரு புஷ் அனுப்பும்:

- **வரிசையில் சேர்கிறது** — _"நீங்கள் வரிசையில் உள்ளீர்கள்."_
- **கழுவல் தொடங்குகிறது** — _"கழுவப்படுகிறது."_
- **தயார்** — _"எடுத்துச் செல்லத் தயார்."_ இதுவே அவர்களைக் கவுண்டருக்குத் திரும்பக் கொண்டுவரும்.
- **ரத்து** — இல்லாத டிக்கெட்டுக்காக யாரும் காத்திருக்காதபடி.
- **இடைநிறுத்தம்** — அவர்களின் இடம் இடைநிறுத்தப்பட்டதே தவிர, இழக்கப்படவில்லை.

தெரிந்துகொள்ளத் தக்க இன்னும் இரண்டு: ஒரு கழுவல் வாடிக்கையாளரை உயர்ந்த விசுவாச நிலைக்கு உயர்த்தும்போது, அப்போதே வாழ்த்து அறிவிப்பு கிடைக்கும். மேலும் **இல்லாத** ஒன்று: டிக்கெட் எடுத்துச் சென்று பணம் செலுத்தியதும் எந்த புஷ்ஷும் இல்லை — ரசீது அறிவிப்பு இல்லை. புள்ளிகளும் வரலாறும் அவர்களின் ஆப்பில் உள்ளன, ஆனால் எதுவும் ஒலிக்காது.

## முதலில் எது உண்மையாக இருக்க வேண்டும்

புஷ்ஷுக்கு வாடிக்கையாளரின் அனுமதி தேவை. அவர்களின் ஆப் பொருத்தமான தருணத்தில் கேட்கும் — முன்பதிவு முடிந்த உடனேயே, அறிவிப்பு தெளிவாகப் பயனுள்ள போது — முதல் திறப்பில் குளிர்ந்த பாப்-அப்பாக அல்ல. மறுத்தால் எதுவும் உடையாது: ஆப்பினுள் டிக்கெட் நகர்வதை நேரலையில் தொடர்ந்து பார்க்கலாம்; அறிவிப்புதான் வராது.

## வாடிக்கையாளர்கள் எதைக் கட்டுப்படுத்துகிறார்கள்

ஆப்பின் அறிவிப்பு அமைப்புகளில், ஒவ்வொரு வாடிக்கையாளரும் தேர்வுசெய்கிறார்கள்:

- **கழுவல் புதுப்பிப்புகள்** மற்றும் **மார்க்கெட்டிங்** — தனித்தனியாக, சேனல் வாரியாக.
- **அமைதி நேரம்** — இரவு சாளரம் (இயல்பாக 22:00–08:00); அதில் மார்க்கெட்டிங் மௌனமாக இருக்கும்.

கழுவல் நிலை புதுப்பிப்புகள் அத்தியாவசியமாகக் கருதப்பட்டு, புஷ் இயக்கத்தில் இருக்கும் வரை எப்போதும் சேர்ப்பிக்கப்படும். மார்க்கெட்டிங் விருப்பங்களை முழுமையாக மதிக்கிறது: விலகல்களும் அமைதி நேரங்களும் நீங்கள் அனுப்பும் ஒவ்வொரு அறிவிப்பிலும் அமல்படுத்தப்படுகின்றன — தவிர்ப்புகள் உங்களுக்கு எப்படி அறிக்கையிடப்படுகின்றன என்பதற்கு அறிவிப்புகள் (பிராட்காஸ்ட்) கட்டுரையைப் பாருங்கள்.

## நேர்மையான எல்லைகள்

- **சொற்றொடர்கள் நிலையானவை; தற்போது ஆங்கிலத்தில் மட்டும்.** வணிகம் வாரியாக அறிவிப்பு உரையைத் திருத்த இன்னும் முடியாது; வாடிக்கையாளரின் ஆப் மொழியையும் அது இன்னும் பின்பற்றாது.
- **WhatsApp மற்றும் SMS இன்று எதையும் அனுப்புவதில்லை.** வாடிக்கையாளர் அமைப்புகளில் அந்த நிலைமாற்றிகள் உள்ளன; தளமும் WhatsApp ஒருங்கிணைப்புக்கான இடத்தை ஒதுக்கியுள்ளது. ஆனால் இன்று எந்த WhatsApp அல்லது SMS செய்தியும் வெளியேறாது — புஷ் மட்டுமே இயங்கும் சேனல். WhatsApp ஆதரவு (உங்கள் சொந்த வணிக எண்ணுடன்) வெளியானதும், இந்தக் கையேட்டில் அதற்கான அமைவு கட்டுரை சேரும்.
